import Vue from 'vue';

Vue.component('shell-app-voucher-promotion-index', () =>
    import(/* webpackChunkName: 'shell-app-voucher-promotion-index' */ './shell-app-voucher-promotion-index'),
);
